import { z } from 'zod'

import { http } from '@/shared/api'

export type BillingSetting = {
  key: string
  value: string
  descriptionRu: string
  descriptionEn: string
}

const settingSchema = z.object({
  key: z.string(),
  value: z.string(),
  description_ru: z.string().nullable(),
  description_en: z.string().nullable(),
})

const listSchema = z.object({ settings: z.array(settingSchema).nullable() })

export async function fetchBillingSettings(signal?: AbortSignal): Promise<BillingSetting[]> {
  const { settings } = await http.get('admin/billing-settings', { schema: listSchema, signal })
  return (settings ?? []).map((raw) => ({
    key: raw.key,
    value: raw.value,
    descriptionRu: raw.description_ru ?? '',
    descriptionEn: raw.description_en ?? '',
  }))
}

export async function putBillingSetting(input: {
  key: string
  value: string
  descriptionRu: string
  descriptionEn: string
}): Promise<void> {
  await http.put(`admin/billing-settings/${input.key}`, {
    json: {
      value: input.value,
      description_ru: input.descriptionRu === '' ? null : input.descriptionRu,
      description_en: input.descriptionEn === '' ? null : input.descriptionEn,
    },
  })
}

export async function deleteBillingSetting(key: string): Promise<void> {
  await http.delete(`admin/billing-settings/${key}`)
}
